export default __webpack_public_path__ + "static/rec-2019-i-f2f4766cf5f54126106e3bab8ea4566f.png";